/**
 * GSAP Core Bundle
 * Imports GSAP core library for bundling with webpack
 */
import gsap from "gsap";

export default gsap;
